// eslint-disable-next-line react-hooks/rules-of-hooks
import { Card, Grid, Typography, FormControlLabel, FormControl, RadioGroup, Radio, TextField, MenuItem, Checkbox, InputAdornment, IconButton, useMediaQuery, useTheme, Button } from '@mui/material';
import { Box } from '@mui/system';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useStyles from '../indexcss';
import { getServices, getServicesById, postQuestionnaire } from '../../../../Utils/apiService';
import KenLoader from '../../../../GlobalComponents/KenLoader';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { AppButton } from '../../../../Components/AppButton';
import KenColors from '../../../../Helpers/Themes/kenColors';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { enqueueSnackbar } from 'notistack';
import { AuthUser } from '../../../../interfaces/Contexts';
import { AuthContext } from '../../../../Helpers/Contexts/authContext';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import routes from '../../../../Utils/routes';
import Slider from '@mui/material/Slider';

const Answers = () => {
  const location = useLocation();
  const { state } = location;
  const classes = useStyles();
  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const { serviceId } = useParams<{ serviceId: string }>();
  const [serviceData, setServiceData] = useState([]);
  const [serviceDataName, setServiceDataName] = useState();
  const [serviceDataQuestion, setServiceDataQuestion] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [shortAnsValues, setShortAnsValues] = useState<any[]>([]);
  const [tempValues, setTempValues] = useState<any[]>([]);
  const userData = user as AuthUser;
  console.log('serviceId12', serviceId, serviceData);
  const [dropdownOption, setDropdownOption] = useState('');
  const [dropdownOptionValue, setDropdownOptionValue] = useState<any[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectMultipleOption, setSelectMultipleOption] = useState<any[]>([]);
  const [fileName, setFileName] = useState<string | null>(null);
  const [fileName1, setFileName1] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [selectedValue1, setSelectedValue1] = useState<any[]>([]);
  const [fileError, setFileError] = useState<string | null>(null);
  const [linearScaleValues, setLinearScaleValues] = useState<any[]>([]);
  const [commentValues, setCommentValues] = useState<any[]>([]);
  const [uploadedFile, setUploadedFile] = useState<any>(null);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>, questionData: any) => {
    const inputValue = event.target.value;
    console.log('inputValue234', inputValue);

    const updatedQuestionData = {
      ...questionData,
      value: inputValue,
    };
    console.log('updatedQuestionData4363', updatedQuestionData);

    setSelectedValue1((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);

      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
  };
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, questionData: any) => {
    const file: any = event.target.files?.[0];

    if (file) {
      const fileType = file.type;
      const validTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

      if (!validTypes.includes(fileType)) {
        setFileError('Only PDF and DOC files are accepted.');
        return;
      }

      setFileError(null); // Clear any previous error
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64File = reader.result as string;
        const base64 = base64File.split(',');
        setFileName(file.name);
        setUploadedFile(file);

        const updatedQuestionData = {
          ...questionData,
          value: base64[1],
        };
        console.log('updatedQuestionData123', updatedQuestionData);

        setFileName1((prevValues) => {
          const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);

          if (existingIndex !== -1) {
            const updatedValues = [...prevValues];
            updatedValues[existingIndex] = updatedQuestionData;
            return updatedValues;
          } else {
            return [...prevValues, updatedQuestionData];
          }
        });
      };

      reader.readAsDataURL(file);
    }
  };

  const handleRemoveFile = (questionData: any) => {
    setFileName(null);
    setUploadedFile(null);
    setFileError(null);

    // Reset the file input value
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    const updatedQuestionData = {
      ...questionData,
      value: '',
    };

    setFileName1((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);

      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
  };

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, questionData: any) => {
    const { name: option } = event.target;

    setSelectMultipleOption((prevValues) => {
      // Find if this question already has selections
      const existingQuestionIndex = prevValues.findIndex((item) => item.Id === questionData.Id);

      let updatedSelections;
      if (existingQuestionIndex !== -1) {
        // Copy existing question data
        const existingQuestion = { ...prevValues[existingQuestionIndex] };

        // Update selected options for this specific question
        existingQuestion.value = existingQuestion.value.includes(option)
          ? existingQuestion.value.filter((v: string) => v !== option) // Unselect option
          : [...existingQuestion.value, option]; // Select option

        // Replace the updated question in the array
        updatedSelections = [...prevValues];
        updatedSelections[existingQuestionIndex] = existingQuestion;
      } else {
        // New selection for a new question
        updatedSelections = [...prevValues, { Id: questionData.Id, value: [option] }];
      }

      return updatedSelections;
    });
  };


  const handleChangeDropdown = (event: SelectChangeEvent, questionData: any) => {
    const inputValue = event.target.value;
    setDropdownOption(event.target.value as string);
    const updatedQuestionData = {
      ...questionData,
      value: inputValue,
    };

    setDropdownOptionValue((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);

      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
  };

  const handleLinearScaleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, questionData: any) => {
    const inputValue = event.target.value;
    const updatedQuestionData = {
      ...questionData,
      value: inputValue,
    };

    setLinearScaleValues((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);

      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
  };

  const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, questionData: any) => {
    const inputValue = event.target.value;
    const updatedQuestionData = {
      ...questionData,
      value: inputValue,
    };

    setCommentValues((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);

      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
  };

  useEffect(() => {
    setLoading(true);
    if (serviceId) {
      getServicesById(serviceId)
        .then(async (res: any) => {
          console.log('res1234', res);
          if (res?.success) {
            setServiceData(res?.data);
            setServiceDataQuestion(res?.data?.[0]);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    }

    getServices()
      .then(async (res: any) => {
        console.log('res123443', res);
        if (res?.success) {
          res.data.map((val: any) => {
            if (val?.id == serviceId) {
              setServiceDataName(val?.name);
            }
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleShortValues = (event: any, questionData: any) => {
    const inputValue = event;
    const updatedQuestionData = {
      ...questionData,
      value: inputValue,
    };

    setShortAnsValues((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);

      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
  };

  const handleSubmit = () => {
    // Check for required fields
    const hasEmptyRequiredFields = serviceDataQuestion?.questionnaire?.some((val: any) => {
      if (val.Is_Required__c) {
        if (val.Question_Type__c === 'Short Answer') {
          return !shortAnsValues.find(item => item.Id === val.Id)?.value;
        } else if (val.Question_Type__c === 'Dropdown') {
          return !dropdownOptionValue.find(item => item.Id === val.Id)?.value;
        } else if (val.Question_Type__c === 'Yes/No') {
          return !selectedValue1.find(item => item.Id === val.Id)?.value;
        } else if (val.Question_Type__c === 'Multiple Choice') {
          return !selectMultipleOption.find(item => item.Id === val.Id)?.value.length;
        } else if (val.Question_Type__c === 'File Upload') {
          return !fileName1.find(item => item.Id === val.Id)?.value;
        } else if (val.Question_Type__c === 'Linear Scale') {
          return !linearScaleValues.find(item => item.Id === val.Id)?.value;
        } else if (val.Question_Type__c === 'Comment') {
          return !commentValues.find(item => item.Id === val.Id)?.value;
        }
      }
      return false;
    });

    if (hasEmptyRequiredFields) {
      enqueueSnackbar({ message: 'Please complete all required fields.', variant: 'error', autoHideDuration: 1000 });
      return;
    }

    const shortAnsValuesResponses = shortAnsValues.map((question: any) => ({
      Respondent__c: userData.ContactId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
    }));

    const dropdownOptionResponse = dropdownOptionValue.map((question: any) => ({
      Respondent__c: userData.ContactId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
    }));

    const selectMultipleOptionResponse = selectMultipleOption.map((question: any) => ({
      Respondent__c: userData.ContactId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value.join(';'),
    }));

    const fileNameResponse = fileName1.map((question: any) => ({
      Respondent__c: userData.ContactId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
    }));

    const selectedValueResponse = selectedValue1.map((question: any) => ({
      Respondent__c: userData.ContactId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
    }));

    const linearScaleResponses = linearScaleValues.map((question: any) => ({
      Respondent__c: userData.ContactId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
    }));

    const commentResponses = commentValues.map((question: any) => ({
      Respondent__c: userData.ContactId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
    }));

    console.log('transformedResponses', shortAnsValuesResponses, selectedValueResponse, fileNameResponse, selectMultipleOptionResponse, dropdownOptionResponse, linearScaleResponses, commentResponses);
    let payload: any = [];
    shortAnsValues.length > 0 &&
      (payload = [
        ...payload,
        {
          fileType: 'not_pdf',
          response: shortAnsValuesResponses,
        },
      ]);
    dropdownOptionValue.length > 0 &&
      (payload = [
        ...payload,
        {
          fileType: 'not_pdf',
          response: dropdownOptionResponse,
        },
      ]);
    selectMultipleOption.length > 0 &&
      (payload = [
        ...payload,
        {
          fileType: 'not_pdf',
          response: selectMultipleOptionResponse,
        },
      ]);
    fileName1.length > 0 &&
      (payload = [
        ...payload,
        {
          fileType: 'pdf',
          response: fileNameResponse,
        },
      ]);
    selectedValue1.length > 0 &&
      (payload = [
        ...payload,
        {
          fileType: 'not_pdf',
          response: selectedValueResponse,
        },
      ]);
    linearScaleValues.length > 0 &&
      (payload = [
        ...payload,
        {
          fileType: 'not_pdf',
          response: linearScaleResponses,
        },
      ]);
    commentValues.length > 0 &&
      (payload = [
        ...payload,
        {
          fileType: 'not_pdf',
          response: commentResponses,
        },
      ]);

    console.log('payload12', payload);

    const data: any = {
      response: payload,
      caseRecord: {
        Subject: serviceDataQuestion.name,
        Description: serviceDataQuestion.name,
        Status: 'New',
        Service_Offering__c: serviceDataQuestion.id,
        ContactId: userData.ContactId,
      },
    };

    postQuestionnaire(data)
      .then((res) => {
        if (res?.data?.success) {
          // debugger
          enqueueSnackbar({ message: 'Your Questionnaire response has been submitted', variant: 'success', autoHideDuration: 1000 });
          navigate(routes.RequestService);
          navigate(-1);
          handleCancelClick();
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };
  console.log('serviceDataQuestion12', serviceDataQuestion, serviceData);
  const handleCancelClick = () => {
    setDropdownOption('');
    setSelectedValue('');
    setSelectedOptions([]);
    setFileName('');
    setLinearScaleValues([]);
    setCommentValues([]);
    setTempValues([]);
    navigate(-1);
  };
  console.log('setShortAnsValue453', shortAnsValues, selectedValue1, fileName1, selectMultipleOption, dropdownOptionValue);

  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={6} md={6} lg={6}>
            <Card className={classes.RequestMainCard1}>
              <Typography
                sx={{
                  fontSize: '15px',
                  fontWeight: 600,
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '12px !important',
                  },
                }}
              >
                {serviceDataName}{' '}
              </Typography>
              <hr style={{ border: '1px solid #BFCEFF' }} />
              {serviceData.map((value: any, index: number) => {
                return (
                  <>
                    <Grid container spacing={2} sx={{ cursor: 'pointer' }} onClick={() => setServiceDataQuestion(value)}>
                      <Grid item xs={8}>
                        <Typography
                          sx={{
                            fontSize: '12px',
                            fontWeight: 500,
                            color: serviceDataQuestion.length == 0 && index == 0 ? '#3061FF' : serviceDataQuestion?.id == value?.id ? '#3061FF' : '#373A45',
                            '@media (min-width: 1280px) and (max-width: 1300px)': {
                              fontSize: '10px !important',
                            },
                          }}
                        >
                          {value?.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} display={'flex'} justifyContent={'end'}>
                        <KeyboardArrowRightIcon style={{ fontSize: '15px' }} />
                      </Grid>
                    </Grid>
                    <hr style={{ border: '1px solid #B2B3B7' }} />
                  </>
                );
              })}
            </Card>
          </Grid>
          <Grid item xs={6} md={6} lg={6}>
            <Card className={classes.RequestMainCard1}>
              <Typography
                sx={{
                  fontSize: '15px',
                  fontWeight: 500,
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '12px !important',
                  },
                }}
              >
                {serviceDataQuestion?.name}
              </Typography>
              <hr style={{ border: '1px solid #BFCEFF' }} />
              <Box
                sx={{
                  '@media (min-width: 1920px) and (max-width: 1940px)': {
                    height: '65vh !important',
                  },
                  '@media (min-width: 1536px) and (max-width: 1636px)': {
                    height: '60vh !important',
                  },
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    height: '55vh !important',
                  },
                  '@media (min-width: 1440px) and (max-width: 1500px)': {
                    height: '62vh !important',
                  },
                }}
                className="scrollbar-cusgray"
              >
                {serviceDataQuestion?.questionnaire?.map((val: any, index: number) => {
                  let option: any = [];
                  if (val.Question_Type__c === 'Dropdown') {
                    option = (val.MCQ_Options__c || '').split(',').map((opt: any) => opt.trim());

                  }
                  let option1: any = [];
                  if (val.Question_Type__c === 'Multiple Choice') {
                    option1 = (val.MCQ_Options__c || '').split(',').map((opt: any) => opt.trim());

                  }
                  return (
                    <>
                      {val.Question_Type__c === 'Short Answer' && (
                        <>
                          <Typography sx={{ fontSize: '10.5px', fontWeight: 500, marginTop: '10px' }}>
                            {val.Question_Label__c} {val.Is_Required__c && <span style={{ color: 'red' }}>*</span>}
                          </Typography>
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            placeholder="Short Answer"
                            value={shortAnsValues.find(item => item.Id === val.Id)?.value || ''}
                            sx={{
                              marginTop: '10px',
                              width: '100%',
                              height: '36px',
                              '& .MuiInputBase-root': {
                                fontSize: '12px',
                                height: '36px',
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '12px',
                              },
                            }}
                            onChange={(e) => handleShortValues(e.target.value, val)}
                          />
                          {(!shortAnsValues.find(item => item.Id === val.Id)?.value && val.Is_Required__c) && (
                            <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>Field is Required</Typography>
                          )}
                        </>
                      )}
                      {val.Question_Type__c === 'Dropdown' && (
                        <>
                          <Typography sx={{ fontSize: '10.5px', fontWeight: 500, marginTop: '10px' }}>
                            {val.Question_Label__c} {val.Is_Required__c && <span style={{ color: 'red' }}>*</span>}
                          </Typography>
                          <FormControl fullWidth sx={{ width: '100%', height: '36px', marginTop: '10px' }}>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={dropdownOption}
                              onChange={(event: any) => handleChangeDropdown(event, val)}
                              sx={{
                                fontSize: '12px',
                                height: '36px',
                                '& .MuiSelect-select': {
                                  fontSize: '12px',
                                },
                              }}
                            >
                              {option.map((values: any) => {
                                console.log('values12343', values);

                                return <MenuItem value={values}>{values}</MenuItem>;
                              })}
                            </Select>
                          </FormControl>
                          {dropdownOption == '' && val.Is_Required__c == true && <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>Field is Required</Typography>}
                        </>
                      )}

                      {val.Question_Type__c === 'Yes/No' && (
                        <div key={index} style={{ marginTop: '10px' }}>
                          <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>
                            {val.Question_Label__c} {val.Is_Required__c && <span style={{ color: 'red' }}>*</span>}
                          </Typography>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            value={selectedValue1.find(item => item.Id === val.Id)?.value || ''}
                            name={`radio-buttons-group-${val.Id}`}
                            onChange={(event) => handleRadioChange(event, val)}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={
                                <Radio
                                  sx={{
                                    '& .MuiSvgIcon-root': {
                                      fontSize: '15px',
                                    },
                                  }}
                                />
                              }
                              label="Yes"
                              sx={{
                                '& .MuiFormControlLabel-label': {
                                  fontSize: '12px',
                                },
                              }}
                            />

                            <FormControlLabel
                              value="No"
                              control={
                                <Radio
                                  sx={{
                                    '& .MuiSvgIcon-root': {
                                      fontSize: '15px',
                                    },
                                  }}
                                />
                              }
                              label="No"
                              sx={{
                                '& .MuiFormControlLabel-label': {
                                  fontSize: '12px',
                                },
                              }}
                            />
                          </RadioGroup>
                          {(!selectedValue1.find(item => item.Id === val.Id)?.value && val.Is_Required__c) &&
                            <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>Field is Required</Typography>
                          }
                        </div>
                      )}
                      {val.Question_Type__c === 'Multiple Choice' && (
                        <div key={index} style={{ marginTop: '10px' }}>
                          <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>
                            {val.Question_Label__c} {val.Is_Required__c && <span style={{ color: 'red' }}>*</span>}
                          </Typography>
                          {option1.map((option: any) => {
                            const selectedQuestion = selectMultipleOption.find((item) => item.Id === val.Id);
                            const isChecked = selectedQuestion ? selectedQuestion.value.includes(option) : false;

                            return (
                              <FormControlLabel
                                key={option}
                                control={
                                  <Checkbox
                                    name={option}
                                    checked={isChecked}
                                    onChange={(event) => handleCheckboxChange(event, val)}
                                    sx={{
                                      marginLeft: '5px',
                                      transform: 'scale(1.2)',
                                      '& .MuiSvgIcon-root': { fontSize: '12px' },
                                    }}
                                  />
                                }
                                label={<Typography sx={{ fontSize: '12px' }}> {option}</Typography>}
                              />
                            );
                          })}

                          {selectedOptions.length == 0 && val.Is_Required__c == true && <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>Field is Required</Typography>}
                        </div>
                      )}
                      {val.Question_Type__c === 'File Upload' && (
                        <div key={index} style={{ marginTop: '10px' }}>
                          <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>
                            {val.Question_Label__c} {val.Is_Required__c && <span style={{ color: 'red' }}>*</span>}
                          </Typography>
                          <TextField
                            label="Upload File"
                            variant="outlined"
                            value={fileName || ''}
                            placeholder="Choose a file"
                            sx={{
                              marginTop: '10px',
                              width: '100%',
                              height: '36px',
                              '& .MuiInputBase-root': {
                                fontSize: '12px',
                                height: '36px',
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '12px',
                              },
                            }}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton onClick={handleIconClick} edge="end">
                                    <FileUploadOutlinedIcon style={{ fontSize: '15px' }} />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <input type="file" accept=".pdf,.doc,.docx" ref={fileInputRef} onChange={(event: any) => handleFileChange(event, val)} style={{ display: 'none' }} />
                          {fileName && (
                            <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                              <Typography sx={{ fontSize: '12px', marginRight: '10px' }}>{fileName}</Typography>
                              <Button variant="outlined" size="small" onClick={() => handleRemoveFile(val)}>
                                Remove
                              </Button>
                            </Box>
                          )}
                          {fileName == null && val.Is_Required__c == true && <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>Field is Required</Typography>}
                          {fileError && <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>{fileError}</Typography>}
                        </div>
                      )}
                      {val.Question_Type__c === 'Linear Scale' && (
                        <div key={index} style={{ marginTop: '10px' }}>
                          <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>
                            {val.Question_Label__c} {val.Is_Required__c && <span style={{ color: 'red' }}>*</span>}
                          </Typography>
                          <Slider
                            value={linearScaleValues.find(item => item.Id === val.Id)?.value || 1}
                            onChange={(e, newValue) => handleLinearScaleChange({ target: { value: String(newValue) } } as React.ChangeEvent<HTMLInputElement>, val)}
                            step={1}
                            marks
                            min={1}
                            max={10}
                            valueLabelDisplay="auto"
                            sx={{
                              marginTop: '10px',
                              width: '79%', // Reduced width
                              marginLeft: '1%', // Added margin 
                              '& .MuiSlider-thumb': {
                                height: '16px',
                                width: '16px',
                              },
                              '& .MuiSlider-valueLabel': {
                                fontSize: '10px',
                              },
                            }}
                          />
                          {(!linearScaleValues.find(item => item.Id === val.Id)?.value && val.Is_Required__c) && (
                            <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>Field is Required</Typography>
                          )}
                        </div>
                      )}
                      {val.Question_Type__c === 'Comment' && (
                        <div key={index} style={{ marginTop: '10px' }}>
                          <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>
                            {val.Question_Label__c} {val.Is_Required__c && <span style={{ color: 'red' }}>*</span>}
                          </Typography>
                          <TextField
                            multiline
                            rows={4}
                            value={commentValues.find(item => item.Id === val.Id)?.value || ''}
                            onChange={(event) => handleCommentChange(event, val)}
                            sx={{
                              marginTop: '10px',
                              width: '100%',
                              '& .MuiInputBase-root': {
                                fontSize: '12px',
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '12px',
                              },
                            }}
                          />
                          {(!commentValues.find(item => item.Id === val.Id)?.value && val.Is_Required__c) && (
                            <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>Field is Required</Typography>
                          )}
                        </div>
                      )}
                    </>
                  );
                })}
              </Box>
              {serviceDataQuestion?.questionnaire !== null && serviceDataQuestion.length != 0 && (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                  <AppButton
                    size="small"
                    type="reset"
                    variant="text"
                    others={{
                      fontSize: '12px',
                      fontWeight: '500',
                      color: KenColors.ClientBlack2,
                      height: '36px',
                    }}
                    onClick={handleCancelClick}
                  >
                    <Typography
                      sx={{
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          fontSize: '10px !important',
                        },
                      }}
                    >
                      Cancel
                    </Typography>
                  </AppButton>

                  <AppButton
                    size="small"
                    onClick={handleSubmit}
                    variant="contained"
                    others={{ fontSize: '12px', fontWeight: '500', padding: '12px', paddingInline: '30px', borderRadius: '8px', height: '36px' }}
                  >
                    <Typography
                      sx={{
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          fontSize: '10px !important',
                        },
                      }}
                    >
                      Submit
                    </Typography>
                  </AppButton>
                </Box>
              )}
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Answers;
